import { ChangeDetectorRef, Directive, OnDestroy, inject } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';

@Directive()
export abstract class BaseComponent implements OnDestroy {
   private readonly destroySubject$ = new Subject<void>();
   private readonly cdr = inject(ChangeDetectorRef);
   private destroyed = false;
   interval: ReturnType<typeof setInterval> | undefined;

   protected takeUntilDestroy<T>(): (source: Observable<T>) => Observable<T> {
      return (source) =>
         source.pipe(
            takeUntil(this.destroySubject$),
            tap({
               next: () => this.notifyView(),
               error: () => this.notifyView(),
               complete: () => this.notifyView(),
            }),
         );
   }

   protected notifyView(): void {
      if (this.destroyed) {
         return;
      }

      try {
         this.cdr.markForCheck();
      } catch {
         /* view already destroyed */
      }
   }

   ngOnDestroy(): void {
      this.destroyed = true;
      this.destroySubject$.next(undefined);
      this.destroySubject$.complete();
      this.tryClearInterval();
   }

   protected tryClearInterval() {
      try {
         if (this.interval) {
            clearInterval(this.interval);
         }
      } catch {
         /* ignore */
      }
      this.interval = undefined;
   }
}
